export default __webpack_public_path__ + "static/media/endorsement-perpani-jkt.7b3f0fff.jpg";